module.exports = __webpack_public_path__ + "img/Masterclass.144c9501.png";